// « Quelqu'un sans l'app » (D-119, à confirmer par Idries) : dans la fiche « Inscrire quelqu'un », le bureau inscrit un
// grand-parent, un voisin, avec son seul prénom ; il compte dans les places prises, sans rappel ni points. Le toucher sur
// le créneau le retire (rien n'est envoyé : il n'a pas de compte).
// Facile à retirer : ce fichier, ses deux appels dans besoins.ts, la migration 20261102310000_benevoles_sans_app.sql et
// scripts/bench/besoins-sans-app.mjs.
import { supabase } from '../lib/supabase';
import type { VolunteerNeed } from '../lib/api';
import type { SlotPerson } from '../lib/besoins-api';
import { lowerFirst } from '../domain/besoins';
import { $, html, openSheet, toast, type Html } from './dom';

const rpc = async (fn: string, args: Record<string, unknown>) => {
  if (!supabase) throw new Error('Base non configurée');
  const { error } = await supabase.rpc(fn, args);
  if (error) throw new Error(error.message);
};

/** Le bloc du bas de la fiche « Inscrire quelqu'un ». */
export const guestBlock = (): Html => html`
  <div class="bm-box" data-guide="bm-guest">
    <p class="eyebrow">Quelqu’un sans l’app</p>
    <p class="muted small">Un grand-parent, un voisin : son prénom suffit. Pas de rappel ni de points pour lui.</p>
    <div class="inline-form"><input id="bm-guest-name" maxlength="40" placeholder="Prénom" aria-label="Prénom de la personne sans l’app" autocomplete="off">
      <button type="button" class="btn btn-ghost btn-sm" id="bm-guest-add">Inscrire</button></div>
  </div>`;

export function wireGuest(sheet: HTMLElement, slotId: string, onAdded: () => void): void {
  const input = $<HTMLInputElement>(sheet, '#bm-guest-name'), btn = $<HTMLButtonElement>(sheet, '#bm-guest-add');
  if (!input || !btn) return;
  btn.addEventListener('click', async () => {
    const name = input.value.trim();
    if (!name) { input.focus(); return; }
    btn.disabled = true;
    try { await rpc('volunteer_guest_add', { p_slot: slotId, p_name: name }); toast(`C’est noté : ${name} est inscrit.`); onAdded(); }
    catch (e) { btn.disabled = false; toast(String((e as Error).message).includes('complet') ? 'Ce créneau vient d’être complété.' : 'Inscription impossible.', 'ko'); }
  });
}

/** Toucher une personne sans l'app sur le créneau : la retirer (rien n'est envoyé). */
export function openGuestRemove(n: VolunteerNeed, p: SlotPerson, onDone: () => void): void {
  openSheet(`${p.name} · ${lowerFirst(n.label)}`, html`
    <div class="bm-sheet">
      <p><strong>${n.title}</strong><br><span class="muted small">Inscrit par le bureau, sans l’app : il n’a ni rappel ni points.</span></p>
      <button type="button" class="btn btn-primary" id="bm-guest-rm">Retirer ${p.name}</button>
      <p class="hint">Rien n’est envoyé : ${p.name} n’a pas l’app. Préviens-le de vive voix.</p>
    </div>`, (sheet, close) => {
    $<HTMLButtonElement>(sheet, '#bm-guest-rm')!.addEventListener('click', async e => {
      const b = e.currentTarget as HTMLButtonElement;
      b.disabled = true;
      try { await rpc('volunteer_guest_remove', { p_id: p.user_id }); close(); toast(`Retiré : ${p.name}.`); onDone(); }
      catch { b.disabled = false; toast('Impossible pour le moment.', 'ko'); }
    });
  });
}
